import React, { Component } from 'react';
import ReactDOM from 'react-dom';

class Dfp extends Component {
 
	 constructor(props){
		  super(props);
		  this.state = {
			  adunit:'',
			  slotId:'ad_'+Math.floor(Math.random()*89999+10000)
		  }

		  if(props.hasOwnProperty('dfpUpdate')){
              props.dfpUpdate();
		  }
	 }
	 
	 componentDidMount(){
	 	const { dfpReady } = this.props
		let that = this;
		let googletag = window.googletag;
		
		 if(ReactDOM.findDOMNode(this).childNodes[0].id!==''){
			 let slotId = ReactDOM.findDOMNode(this).childNodes[0].id;
			 
			 googletag.cmd.push(function() {				 
				let adunitCode = that.props.adUnit;
				let sizes = that.props.sizes;
				let sizeMapping = that.props.sizeMapping;
				let sizeMapBuilder = googletag.sizeMapping();
				let targeting = that.props.targeting;
				let callback = that.props.callback;
				
				let adunit = googletag.defineSlot('/1038353/'+adunitCode, sizes, slotId).addService(googletag.pubads());
				that.setState({ adunit:adunit });
				if(typeof sizeMapping !== 'undefined' && sizeMapping.length){
					for(var smIdx = 0; smIdx<sizeMapping.length; smIdx++){
						sizeMapBuilder.addSize(sizeMapping[smIdx].viewport,sizeMapping[smIdx].sizes);
					}
					console.log('sizeMapBuilder built')
					adunit.defineSizeMapping(sizeMapBuilder.build());
				}
				if(typeof targeting !== 'undefined' && targeting.length){
					for(var tIdx = 0; tIdx<targeting.length; tIdx++){
						adunit.setTargeting(targeting[tIdx].key,targeting[tIdx].value);
					}
				}
				googletag.display(slotId);

				if(typeof dfpReady == 'function'){
                    dfpReady(adunit)
					console.log('dfpReady function' )
				}
				else{
                    googletag.pubads().refresh([adunit]);
                    console.log('refresh' )
                }

				// googletag.pubads().refresh([adunit]);
				if(typeof callback !== 'undefined')
				googletag.pubads().addEventListener('slotRenderEnded', function(evnt){
					callback(evnt,that.state.adunit)
				})
			 });
		 }
	 }
	
	 render() {
		const { slotId } = this.state;
		const { adUnit } = this.props;
		
		return (
			<div className="dfp-slot text-center">
				<div id={slotId}></div>
			</div>
		)
	 }
}

export default Dfp;


// WEBPACK FOOTER //
// ./src/Dfp.js